import "../css/app.css";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";

Alpine.plugin(focus);
Alpine.plugin(intersect);

// Custom js goes here
import "./utilities/utility-functions-accessible-navigation";
import "./handle-navigation";

window.Alpine = Alpine;

async function boot() {
    // Make sure Alpine loads first before this function
    if (document.body.classList.contains("home")) {
        const { handleHomeAnimations } = await import(
            "./animations/home-animations.js"
        );
        handleHomeAnimations(Alpine);
    }

    Alpine.start();
}

boot();
